import { 
  FETCH_SUBSCRIPTION_NOTIFICATIONS_REQUEST, 
  FETCH_SUBSCRIPTION_NOTIFICATIONS_COMMIT, 
  FETCH_SUBSCRIPTION_NOTIFICATIONS_ROLLBACK,
  UPDATE_SUBSCRIPTION_DATA
} from '../actions';

const initialState = {
  data: {
    salesVolume: null,
    salesLimit: null,
    subscription: null,
    // accessCodesUsed: 0,
    // projectsCount: 0,
    invoices: [],
  },
  lastFetchedAt: null,
  isLoading: false,
  error: null
};

export function subscriptionNotifications(state = initialState, action) {
  switch (action.type) {
    case FETCH_SUBSCRIPTION_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case FETCH_SUBSCRIPTION_NOTIFICATIONS_COMMIT:
      return {
        ...state,
        data: action.payload,
        lastFetchedAt: new Date().toISOString(),
        isLoading: false,
        error: null
      };
    case FETCH_SUBSCRIPTION_NOTIFICATIONS_ROLLBACK:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case UPDATE_SUBSCRIPTION_DATA:
      return {
        ...state,
        data: action.payload,
        lastFetchedAt: new Date().toISOString(),
        isLoading: false,
        error: null
      };
    default:
      return state;
  }
} 